export function getPendingLicenseKey(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem('pending_license_key') || null
}

export function clearPendingLicenseKey(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('pending_license_key')
}
